document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    document.querySelectorAll(".bss-b2b-price-no-vat").forEach(el => {
      let txt = el.textContent;

      // Add dot after 'kr'
      txt = txt.replace(" kr", " kr.");

      // Add dot after mva (case-insensitive)
      txt = txt.replace(/mva\b/i, "mva.");

      el.textContent = txt;
    });
  }, 1000);
});

document.addEventListener("DOMContentLoaded", function () {
  const bar1 = document.querySelector('.site-announcement');
  const bar2 = document.querySelector('.b2b-cta-messaging');

  if (!bar1 || !bar2) return;

  let showFirst = true;

  // Initial state
  bar1.style.display = 'block';
  bar2.style.display = 'none';

  setInterval(() => {
    if (showFirst) {
      bar1.style.display = 'none';
      bar2.style.display = 'block';
    } else {
      bar1.style.display = 'block';
      bar2.style.display = 'none';
    }
    showFirst = !showFirst;
  }, 2000);
});









(function () {
  const ORIGINAL_BUTTON_ID = "bss-b2b-net-term-button";
  const CONTAINER_ID = "custom-pay-by-invoice-button";
  const CUSTOM_BUTTON_ID = "custom-pay-by-invoice-clone";

  function createOrUpdateButton() {
    const originalBtn = document.getElementById(ORIGINAL_BUTTON_ID);
    const container = document.getElementById(CONTAINER_ID);

    if (!originalBtn || !container) return;

    const style = window.getComputedStyle(originalBtn);

    // Check if button is visible and display is inline-flex
    if (style.display !== "inline-flex") return;

    // Prevent duplicate button
    if (document.getElementById(CUSTOM_BUTTON_ID)) return;

    const newBtn = document.createElement("button");
    newBtn.id = CUSTOM_BUTTON_ID;
    newBtn.type = "button";
    newBtn.textContent = originalBtn.textContent;

    // Optional styling (adjust as needed)
    newBtn.style.display = "inline-flex";
    newBtn.style.cursor = "pointer";

    newBtn.addEventListener("click", function () {
      originalBtn.click();
    });

    container.appendChild(newBtn);
  }

  // Run on page load
  document.addEventListener("DOMContentLoaded", createOrUpdateButton);

  // Mutation Observer
  const observer = new MutationObserver(() => {
    createOrUpdateButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });
})();